module.exports = __webpack_public_path__ + "img/android.f580afe7.svg";